import { Box, Slide, Stack } from "@mui/material";
import React, { useEffect } from "react";
import {
  Color,
  FontStyle,
  JobDisplays,
  SurveyButtonStyle,
} from "../../../constants";
import CloseIcon from "@mui/icons-material/Close";
import { OverlayNames } from "../DescriptionOverlay";

import { setUserFinishedTutorial } from "../../../service/CookieService";
import { teamInfo } from "../../../utils/avatarUtils";

const styles = {
  float: {
    position: "fixed",
    top: 0,
    width: "100%",
    height: "100%",
    left: 0,
    // backgroundColor: "#fff7",
    zIndex: 1002,
  },
  container: {
    position: "absolute",
    // do not use transform, since transitions will be weird when transform and top/left change
    // top: "50%",
    // left: "50%",
    // transform: "translate(-50%, -50%)",
    // transition: "all 0.4s ease",
    // 380 x 290
    top: "calc(50% - 145px)",
    left: "calc(50% - 190px)",
    transition:
      "top 0.4s ease, left 0.4s ease, right 0.4s ease, bottom 0.4s ease",
    maxWidth: "380px",

    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,

    ...FontStyle.body,
    fontSize: "16px",
    zIndex: 1001,
  },
  inner: {
    padding: JobDisplays.padding,
  },
  footer: {
    borderTop: "1px solid #e0e0e0",
    width: "100%",
    backgroundColor: "#fff",
    // backgroundColor: "#f5f5f5",
    // color: "#757575",
    color: "rgba(0, 0, 0, 0.6)",
    fontSize: "14px",
    borderRadius: `0 0 ${JobDisplays.borderRadius} ${JobDisplays.borderRadius}`,
  },
  footerPadding: {
    padding: JobDisplays.padding,
    py: "8px",
    userSelect: "none",
  },
  footerButtonBack: {
    cursor: "pointer",
    // backgroundColor: "#d8d8d8",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#000",
    },
  },
  footerButtonNext: {
    ...SurveyButtonStyle.gradientColor,
    // fontWeight: 400,
    cursor: "pointer",
    // backgroundColor: Color.lightGreen,
    transition: "all 0.2s ease",
    borderRadius: `0 0 ${JobDisplays.borderRadius} 0`,
    // "&:hover": {
    //   color: "#000",
    //   backgroundColor: Color.mainGreen,
    // },
  },
};

const TutorialAvatar = ({ idx }) => {
  const { name, title, icon } = teamInfo[idx];
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <img
        src={icon}
        style={{ width: "36px", height: "36px", borderRadius: "50%" }}
      />
      <Stack direction="column" spacing={0}>
        <Box sx={{ fontWeight: "bold" }}>{name}</Box>
        <Box sx={{ color: "#aaa", fontSize: "14px" }}>{title}</Box>
      </Stack>
    </Stack>
  );
};
const TutorialStack = ({ children }) => {
  return (
    <Stack
      sx={{
        fontSize: "14px",
      }}
      spacing="8px">
      {children}
    </Stack>
  );
};

const Intro1 = () => {
  return (
    <>
      <TutorialAvatar idx={0} />
      <Box sx={{ fontWeight: "bold", paddingBottom: "8px", paddingTop: "8px" }}>
        {" "}
        Welcome to Fetti!
      </Box>
      <TutorialStack>
        <Box>
          We're excited to help you find the perfect job that matches your
          skills, preferences, and interests.
        </Box>
        <Box>
          Great news - it looks like you've already created your profile, so
          you're one step closer to finding your dream job!
        </Box>
        <Box>
          Now, let's get started on exploring job opportunities that match your
          preferences.
        </Box>
      </TutorialStack>
    </>
  );
};
const Matches2 = () => {
  return (
    <>
      <TutorialAvatar idx={1} />
      <Box sx={{ fontWeight: "bold", paddingBottom: "8px", paddingTop: "8px" }}>
        Meet your Matches
      </Box>
      <TutorialStack>
        <Box>
          Discover relevant job opportunities based on your skills, preferences,
          and qualifications.
        </Box>
      </TutorialStack>
    </>
  );
};
const Details3 = () => {
  return (
    <>
      <TutorialAvatar idx={2} />
      <Box sx={{ fontWeight: "bold", paddingBottom: "8px", paddingTop: "8px" }}>
        View Job Details & Apply
      </Box>
      <TutorialStack>
        <Box>
          Learn more about job openings and take action by reviewing the job
          description, applying for the job, or saving it for later.
        </Box>
      </TutorialStack>
    </>
  );
};
const Help4 = () => {
  return (
    <>
      <TutorialAvatar idx={3} />
      <Box sx={{ fontWeight: "bold", paddingBottom: "8px", paddingTop: "8px" }}>
        Tutorials & Recruiting Resources
      </Box>
      <TutorialStack>
        <Box>
          Access helpful resources to enhance your job search, such as resume
          writing tips, interview preparation advice, or cover letter templates.
        </Box>
      </TutorialStack>
    </>
  );
};
const LetsGo5 = () => {
  return (
    <>
      {/* <TutorialAvatar idx={4} /> */}
      <Box sx={{ fontWeight: "bold", paddingBottom: "8px", paddingTop: "8px" }}>
        Let's Get Started!
      </Box>
      <TutorialStack>
        <Box>
          We're excited to help you find your next opportunity - let's get
          started!
        </Box>
      </TutorialStack>
    </>
  );
};
const panels = [Intro1, Matches2, Details3, Help4, LetsGo5];

const Footer = ({ tutorialSteps, setTutorialSteps }) => {
  return (
    <Stack direction="row" justifyContent="space-between" sx={styles.footer}>
      <Box sx={styles.footerPadding}>
        Step {tutorialSteps} of {panels.length}
      </Box>
      <Stack
        direction="row"
        sx={{
          borderRadius: `0 0 ${JobDisplays.borderRadius} 0`,
        }}>
        {tutorialSteps > 1 && (
          <Box
            sx={{ ...styles.footerPadding, ...styles.footerButtonBack }}
            onClick={() => setTutorialSteps((steps) => steps - 1)}>
            Back
          </Box>
        )}
        <Box
          sx={{ ...styles.footerPadding, ...styles.footerButtonNext }}
          onClick={() => {
            if (tutorialSteps === panels.length) {
              setUserFinishedTutorial();
              setTutorialSteps(0);
            } else {
              setTutorialSteps((steps) => steps + 1);
            }
          }}>
          {tutorialSteps === panels.length ? "Finish" : "Next"}
        </Box>
      </Stack>
    </Stack>
  );
};

const CloseButton = ({ handleClose }) => {
  return (
    <Box
      onClick={handleClose}
      sx={{
        position: "absolute",
        top: "8px",
        right: "8px",
        cursor: "pointer",
        color: "#9e9e9e",
        transition: "all 0.2s ease",
        "&:hover": {
          color: "#616161",
        },
      }}>
      <CloseIcon />
    </Box>
  );
};

const LeftTriangle = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        // top: 0,
        left: 0,
        top: "10%",
        // left: "0%",
        transform: "translate(-100%, 0)",
        width: 0,
        height: 0,
        // borderLeft: "20px solid #000",
        borderTop: "15px solid transparent",
        borderBottom: "15px solid transparent",
        borderRight: "20px solid #fff",
        zIndex: 1001,
      }}
    />
  );
};
const RightTriangle = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        // top: 0,
        left: "100%",
        top: "10%",
        // left: "0%",
        // transform: "translate(-100%, 0)",
        width: 0,
        height: 0,
        // borderLeft: "20px solid #000",
        borderTop: "15px solid transparent",
        borderBottom: "15px solid transparent",
        borderLeft: "20px solid #fff",
        zIndex: 1001,
      }}
    />
  );
};

const JobTutorialWindow = ({
  setShowDescriptionOverlay,
  setTutorialSteps,
  tutorialSteps,
  tutSizes,
}) => {
  return (
    <Slide
      in={tutorialSteps > 0}
      direction="up"
      mountOnEnter
      unmountOnExit
      timeout={600}>
      <Box sx={styles.float}>
        <Stack
          sx={{
            ...styles.container,
            ...(tutorialSteps === 2 &&
              (tutSizes[2]
                ? {
                    top: `calc(50% + ${tutSizes[2].rect.top - 90}px)`,
                    left: tutSizes[2].rect.left + tutSizes[2].rect.width - 20,
                  }
                : {
                    // top: "200px",
                    top: "calc(50% + 125px)",
                    left: "calc(50% - 160px)",
                  })),
            ...(tutorialSteps === 3 &&
              (tutSizes[3]
                ? {
                    top:
                      (tutSizes[3].rect.top + tutSizes[3].rect.bottom) / 2 - 70,
                    left:
                      (tutSizes[3].rect.left + tutSizes[3].rect.right) / 2 +
                      120,
                  }
                : {
                    top: "calc(50% - 75px)",
                    left: "calc(60% + 150px)",
                  })),
            ...(tutorialSteps === 4 &&
              (tutSizes[4]
                ? {
                    top:
                      tutSizes[4].rect.top +
                      (tutSizes[4].rect.width * 1.78) / 2 -
                      70,
                    left: tutSizes[4].rect.left - 344,
                  }
                : {
                    top: "calc(50% + 75px)",
                    left: "calc(50% + 120px)",
                  })),
            ...(tutorialSteps === 5 &&
              {
                // use default in styles.container
                // top: "50%",
                // left: "50%",
              }),
          }}
          direction="column"
          alignItems="center">
          <CloseButton
            handleClose={() => {
              setTutorialSteps(0);
              setUserFinishedTutorial();
            }}
          />
          {tutorialSteps > 1 && tutorialSteps < 4 && <LeftTriangle />}
          {tutorialSteps === 4 && <RightTriangle />}
          <Box sx={styles.inner}>{panels[tutorialSteps - 1]()}</Box>
          <Footer
            tutorialSteps={tutorialSteps}
            setTutorialSteps={setTutorialSteps}
          />
        </Stack>
      </Box>
    </Slide>
  );
};
export default JobTutorialWindow;
